import { defineMessages } from 'react-intl';
import {
  English,
  EnglishAustralia,
  EnglishUnitedKingdom,
  French,
  FrenchCanada,
  Spanish,
  German,
  Development,
} from '../../locale-context-provider/locale-codes';

export const messages = defineMessages({
  [English]: {
    description: 'English language selector',
    defaultMessage: 'English (US & CA)',
    id: '3BwrmM',
  },
  [EnglishAustralia]: {
    description: 'English Australia language selector',
    defaultMessage: 'English (AUS & NZ)',
    id: 'OtOp7i',
  },
  [EnglishUnitedKingdom]: {
    description: 'English UnitedKingdom language selector',
    defaultMessage: 'English (UK & IE)',
    id: 'kgvaoX',
  },
  [French]: {
    description: 'French language selector',
    defaultMessage: 'French',
    id: 'dm9bYa',
  },
  [FrenchCanada]: {
    description: 'French Canada language selector',
    defaultMessage: 'French (Canada)',
    id: 'DokhP4',
  },
  [Spanish]: {
    description: 'Spanish language selector',
    defaultMessage: 'Spanish',
    id: 'M81vEM',
  },
  [German]: {
    description: 'German language selector',
    defaultMessage: 'German',
    id: 'f6omRd',
  },
  [Development]: {
    description: 'Development language selector',
    defaultMessage: 'Development',
    id: 'IxFr9Y',
  },
});
